import gql from "graphql-tag";

export const createProfileGQL = gql`
  mutation CreateProfile($input: CreateProfileInput!) {
    createProfile(input: $input) {
      message
    }
  }
`;

export const updateProfileGQL = gql`
  mutation UpdateProfile($input: UpdateProfileInput!) {
    updateProfile(input: $input) {
      message
    }
  }
`;

export const generateProfileTokenGQL = gql`
  mutation GenerateProfileToken($input: GenerateProfileTokenInput!) {
    generateProfileToken(input: $input) {
      token
    }
  }
`;

export const requestOtpGQL = gql`
  mutation RequestOtp($input: RequestOtpInput!) {
    requestOtp(input: $input) {
      requestId
      expiresAt
    }
  }
`;

export const verifyOtpGQL = gql`
  mutation VerifyOtp($input: VerifyOtpInput!) {
    verifyOtp(input: $input) {
      requestId
    }
  }
`;
